import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SheetBodyDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    scroll: {
        flexShrink: 1,
        flexGrow: 1,
        ...webStyle({
            overscrollBehavior: "contain"
        })
    },
    scrollContent: {
        flexDirection: "column"
    },
    bottomContainer: {
        flexDirection: "column"
    }
});

export const useStyles = ({
    spaces
}: SheetBodyDynamicStyleType) => {
    const styles = {
        scrollContent: {
            paddingHorizontal: spaces.spacingLg,
            paddingBottom: spaces.spacingLg,
            paddingTop: spaces.spacingSm,
            gap: spaces.spacingLg
        } as Mutable<ViewStyle>,
        container: {
            gap: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
